import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from 'reactstrap';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIcon from '../../../elements/oe-icon';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import {OEPresentationPlayableFlags, OEPresentationDefaultAnimatableState} from '../../presentation/oe-presentation-model';
import OEPresentationSlideList from '../../presentation/oe-presentation-slide-list';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../../lib/react/update-retarder';
import {OETransitionGroup} from '../../../../lib/components/oe-transitions';

export class OEMediaCenterItemPresSlideItemContent extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            tooltipOpen: false
        };

        this.onRef = this.onRef.bind(this);

        this.onClick = this.onClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    startTooltip()   {
        if(this.timer) return;
        this.timer = setTimeout(() => { this.setState({tooltipOpen: true}); this.timer = null; }, 1000);
    }

    finishTooltip()   {
        if(this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.setState({tooltipOpen: false});
    }

    onRef(ref) {
        this.setState({ref: ref});
    }

    render()    {
        let data = this.props.data;

        let tooltip = !this.state.ref || !this.state.ref.parentElement || !data.desc || data.desc === '' ? null :
            <Tooltip
                boundariesElement="body"
                placement="right"
                isOpen={this.state.tooltipOpen}
                target={this.state.ref.parentElement}
                delay={{show: 500, hide: 0}}
            >
                {data.desc}
            </Tooltip>;

        return (
            <div className="extra-light-hover-bg container" onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} ref={this.onRef}>
                {tooltip}
                <div className="detail">
                    <div className="index">
                        {(data.index + 1).toString() + '.'}
                    </div>
                    <div className="name">
                        {data.name}
                    </div>
                </div>
                <div className="preview" style={{backgroundImage: 'url(' + data.img + ')'}}></div>
            </div>
        );
    }

    onClick()   {
        this.finishTooltip();
    }

    onMouseEnter()    {
        this.startTooltip();
    }

    onMouseLeave()    {
        this.finishTooltip();
    }
};

export default class OEMediaCenterItemPres extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.activePres = -1;
        this.activeSlide = -1;
        this.expanded = false;

        this.defStats = {
            duration: {duration: 0, slides: 0},
            isPlayable: false,
            hasAudioTrack: false,
        };

        this.state = {
            expanded: this.expanded,
            tooltipOpen: false,
            stats: clone(this.defStats)
        };

        this.onPresentationDurationChanged = this.onPresentationDurationChanged.bind(this);
        this.onActivePresentationChanged = this.onActivePresentationChanged.bind(this);
        this.onActiveSlideChanged = this.onActiveSlideChanged.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);
        this.onPresentationAnimatableStateChanged = this.onPresentationAnimatableStateChanged.bind(this);

        this.onRef = this.onRef.bind(this);
        this.onHeaderRef = this.onHeaderRef.bind(this);
        this.onPresentationSlideListRef = this.onPresentationSlideListRef.bind(this);
        this.onContentRef = this.onContentRef.bind(this);

        this.onHeaderClicked = this.onHeaderClicked.bind(this);
        this.onHeaderMouseEnter = this.onHeaderMouseEnter.bind(this);
        this.onHeaderMouseLeave = this.onHeaderMouseLeave.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onLabelClicked = this.onLabelClicked.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onPresentationSlideItemClick = this.onPresentationSlideItemClick.bind(this);
        this.onPresentationSlideListResize = this.onPresentationSlideListResize.bind(this);
        this.renderPresentationSlideItemContent = this.renderPresentationSlideItemContent.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.item.id !== this.props.item.id)   {
            if(nextProps.elementRef)    {
                nextProps.elementRef(null, this.props.item.id);
                nextProps.elementRef(this.ref, nextProps.item.id);
            }
        } else if(nextProps.elementRef !== this.props.elementRef)   {
            if(nextProps.elementRef)   nextProps.elementRef(this.ref, nextProps.item.id);
        }

        if(nextProps.item.item.index !== this.props.item.item.index || nextProps.presPlayableFlags !== this.props.presPlayableFlags)    {
            this.updateStats(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDurationChanged, this.onPresentationDurationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDurationChanged, this.onPresentationDurationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
    }

    setExpanded(expanded)   {
        this.expanded = expanded;
        this.setState({expanded: this.expanded});
    }

    startTooltip()   {
        if(this.timer) return;
        this.timer = setTimeout(() => { this.setState({tooltipOpen: true}); this.timer = null; }, 1000);
    }

    finishTooltip()   {
        if(this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.setState({tooltipOpen: false});
    }

    updateStats(props)   {
        if(!this.oe.isReady()) return;
        props = props || this.props;

        let pres = this.oe.sharedInterface.getUIControllerPresentation();
        let animatableState = pres.getPresentationAnimatableStateID(props.item.item.index) || OEPresentationDefaultAnimatableState;
        let presPlayableFlags = pres.getPresentationPlayableFlagsID(props.item.item.index);
        if(typeof(presPlayableFlags) !== 'number')  presPlayableFlags = props.presPlayableFlags;

        let stats = {
            duration: {
                duration: pres.getPresentationDurationID(props.item.item.index),
                slides: animatableState.previewSlideCount
            },
            isPlayable: OEPresentationPlayableFlags.isPlayable(presPlayableFlags, animatableState),
            hasAudioTrack: animatableState.hasAudioTrack
        };

        this.setState({stats: stats});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.activePres = -1;
            this.activeSlide = -1;
            this.expanded = false;

            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.setState({
                expanded: this.expanded,
                tooltipOpen: false,
                stats: clone(this.defStats)
            });

            return;
        }

        this.activePres = this.oe.sharedInterface.getUIControllerPresentation().getActivePresentationID();
        this.activeSlide = this.oe.sharedInterface.getUIControllerPresentation().getActiveSlideID();

        retardUpdate(this, () => {
            this.updateStats();
        });
    }

    onSlideChanged(slideID)    {
        this.activeSlide = slideID;
        if(!this.props.enabled || this.activePres !== this.props.item.item.index) return;
        let id = slideID;

        if(!this.slideListRef)   {
            if(this.props.onItem)   this.props.onItem(this.props.index, this.props.item.id, id, null);
        } else {
            this.slideListRef.itemRect(id, rect => {
                if(this.contentRef && rect) {
                    rect.x += this.contentRef.offsetLeft;
                    rect.y += this.contentRef.offsetTop;
                }
                if(this.props.onItem)   this.props.onItem(this.props.index, this.props.item.id, id, rect);
            });
        }
    }

    onPresentationDurationChanged(message, userInfo)   {
        if(userInfo.presID !== this.props.item.item.index) return;
        this.updateStats();
    }

    onActivePresentationChanged(message, userInfo)   {
        this.activePres = userInfo.presID;
        this.activeSlide = this.oe.sharedInterface.getUIControllerPresentation().getActiveSlideID();
        if(!this.props.enabled || this.activePres !== this.props.item.item.index)   return;
        if(!this.expanded)  {
            if(this.props.onItem)   this.props.onItem(this.props.index, this.props.item.id, null, {x: 0, y: 0, width: 0, height: 0});
        } else {
            this.onSlideChanged(this.activeSlide);
        }
    }

    onActiveSlideChanged(message, userInfo)    {
        this.onSlideChanged(userInfo.slideID);
    }

    onPresentationDataChanged(message, userInfo)    {
        if(userInfo.presID !== this.props.item.item.index || !(userInfo.changeFlags & this.oe.Module.PresentationDataChangeFlags.playable.value))    return;
        this.updateStats();
    }

    onPresentationAnimatableStateChanged(message, userInfo)   {
        if(userInfo.presID !== this.props.item.item.index) return;
        this.updateStats();
    }

    onRef(ref) {
        if(this.ref === ref) return;
        this.ref = ref;
        if(this.props.elementRef)   this.props.elementRef(ref, this.props.item.id);
    }

    onHeaderRef(ref)    {
        this.setState({headerRef: ref});
    }

    onPresentationSlideListRef(ref) {
        this.slideListRef = ref;
    }

    onContentRef(ref) {
        this.contentRef = ref;
    }

    renderPresentationSlideItemContent(data)    {
        return <OEMediaCenterItemPresSlideItemContent data={data}/>
    }

    renderExpandedContent() {
        if(!this.state.expanded) return null;

        return (
            <div className="content" ref={this.onContentRef}>
                <OEPresentationSlideList
                    moduleId={this.props.moduleId}
                    enabled={this.props.enabled}
                    overrideUIEnabled={true}
                    presID={this.props.item.item.index}
                    onlyPreviewSlides={true}
                    noScrollbar={true}
                    renderItemContent={this.renderPresentationSlideItemContent}
                    onItemClicked={this.onPresentationSlideItemClick}
                    ref={this.onPresentationSlideListRef}
                />
            </div>
        );
    }

    render() {
        let tooltip = !this.state.headerRef || !this.props.item.desc || this.props.item.desc === '' ? null :
            <Tooltip
                boundariesElement="body"
                placement="right"
                isOpen={this.state.tooltipOpen}
                target={this.state.headerRef}
                delay={{show: 500, hide: 0}}
            >
                {this.props.item.desc}
            </Tooltip>;

        let durationLabel = this.state.stats.isPlayable ?
            <div className="duration">
                <OEIcon code={OEIconCodes.mcPresentationDuration}/>{OEToolbox.numberToString(Math.floor(this.state.stats.duration.duration / 60), 2) + ':' + OEToolbox.numberToString(Math.floor(this.state.stats.duration.duration % 60), 2)}
            </div> :
            <div className="duration">
                <OEIcon code={OEIconCodes.mcPresentationSlides}/>{this.state.stats.duration.slides.toString()}
            </div>;
        
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div
                    className={'media-center-item-pres ' + this.props.className + (this.props.selected ? ' selected' : '') + (!this.props.enabled ? ' disabled' : '')}
                    style={this.props.style}
                    ref={this.onRef}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                >
                    {tooltip}

                    <div className="header " onClick={this.onHeaderClicked} onMouseEnter={this.onHeaderMouseEnter} onMouseLeave={this.onHeaderMouseLeave} ref={this.onHeaderRef} >
                        <div className="border-frame"/>

                        <div className="extra-light-hover-bg toggle clicktarget" onClick={this.onToggle}>
                            <div className={'rot-toggle' + (this.state.expanded ? ' rot-rotate-toggle' : '')}>
                                <OEIcon code={OEIconCodes.caretRight}/>
                            </div>
                        </div>

                        <div className="std-label-text-color-bg separator vertical" />

                        <div className="extra-light-hover-bg right clicktarget" onClick={this.onLabelClicked}>
                            <div className="label">
                                {this.props.item.label}
                            </div>

                            {durationLabel}

                            <OEIcon className="sound-icon" code={this.state.stats.hasAudioTrack ? OEIconCodes.mcItemWithSound : OEIconCodes.mcItemWithoutSound} onClick={this.onLabelClicked}/>
                        </div>

                    </div>
                        
                    <OETransitionGroup mountOnEnter={true} unmountOnExit={true} onAnimFinished={this.onPresentationSlideListResize}>
                        {this.renderExpandedContent()}
                    </OETransitionGroup>

                </div>
            </React.Fragment>
        );
    }

    onHeaderClicked()   {
        this.finishTooltip();
    }

    onHeaderMouseEnter()    {
        this.startTooltip();
    }

    onHeaderMouseLeave()    {
        this.finishTooltip();
    }

    onToggle()  {
        this.setExpanded(!this.expanded);
    }

    onLabelClicked()   {
        this.onClick();
    }

    onClick()   {
        if(!this.props.enabled) return;
        if(this.props.onItem)   this.props.onItem(this.props.index, this.props.item.id, null, {x: 0, y: 0, width: 0, height: 0});
        if(this.props.onClick)  this.props.onClick(this.props.index, this.props.item.id, null);
    }

    onMouseEnter()  {
        if(this.props.onMouseEnter) this.props.onMouseEnter(this.props.index, this.props.item.id);
    }

    onMouseLeave()  {
        if(this.props.onMouseLeave) this.props.onMouseLeave(this.props.index, this.props.item.id);
    }

    onPresentationSlideItemClick(id)   {
        if(!this.props.enabled) return;
        let rect = this.slideListRef ? this.slideListRef.itemRect(id) : null;
        if(this.contentRef && rect) {
            rect.x += this.contentRef.offsetLeft;
            rect.y += this.contentRef.offsetTop;
        }
        if(this.props.onItem)   this.props.onItem(this.props.index, this.props.item.id, id, rect);
        if(this.props.onClick)  this.props.onClick(this.props.index, this.props.item.id, id);
    }

    onPresentationSlideListResize() {
        if(!this.oe.isReady() || !this.slideChangeAfterResize) return;
        this.slideChangeAfterResize = false;
        this.onSlideChanged(this.activeSlide);
    }
}

OEMediaCenterItemPres.defaultProps = {
    className:'',
    moduleId: '',
    enabled: true,
    selected: false,
    presPlayableFlags: OEPresentationPlayableFlags.all
};

OEMediaCenterItemPres.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    moduleId: PropTypes.string,
    enabled: PropTypes.bool,
    selected: PropTypes.bool,
    presPlayableFlags: PropTypes.number,
    elementRef: PropTypes.func,     // function(ref, id) {},
    onItem: PropTypes.func,
    onClick: PropTypes.func,        // function(index, id, slideID) {},
    onMouseEnter: PropTypes.func,   // function(index, id) {},
    onMouseLeave: PropTypes.func    // function(index, id) {},
};